(() => {
  const selector = '[data-tt-design-carousel]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initCarousel = (root) => {
    if (!root || root.dataset.ttCarouselReady === 'true') return;

    const viewport = root.querySelector('[data-tt-design-viewport]');
    const track = root.querySelector('[data-tt-design-track]');
    const progress = root.querySelector('[data-tt-design-progress]');
    const previousButton = root.querySelector('[data-tt-design-prev]');
    const nextButton = root.querySelector('[data-tt-design-next]');
    const cards = Array.from(root.querySelectorAll('[data-tt-design-card]'));
    if (!viewport || !track || cards.length < 2) return;

    root.dataset.ttCarouselReady = 'true';

    let frame = false;
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const setNeutralTransforms = () => {
      cards.forEach((card) => {
        card.style.setProperty('--tt-reel-x', '0px');
        card.style.setProperty('--tt-reel-y', '0px');
        card.style.setProperty('--tt-reel-z', '0px');
        card.style.setProperty('--tt-reel-rotate-y', '0deg');
        card.style.setProperty('--tt-reel-rotate-z', '0deg');
        card.style.setProperty('--tt-reel-scale', '1');
        card.style.setProperty('--tt-reel-opacity', '1');
      });
    };

    const updateCardTransforms = () => {
      frame = false;

      const maxScroll = Math.max(viewport.scrollWidth - viewport.clientWidth, 1);
      const progressValue = clamp(viewport.scrollLeft / maxScroll, 0, 1);
      const progressOffset = progressValue * 82;
      root.style.setProperty('--tt-carousel-progress', progressValue.toFixed(4));
      root.style.setProperty('--tt-carousel-progress-offset', `${progressOffset.toFixed(2)}%`);
      if (progress) {
        progress.style.setProperty('--tt-carousel-progress', progressValue.toFixed(4));
        progress.style.setProperty('--tt-carousel-progress-offset', `${progressOffset.toFixed(2)}%`);
      }

      if (reducedMotion.matches) {
        setNeutralTransforms();
        return;
      }

      const viewportRect = viewport.getBoundingClientRect();
      const center = viewportRect.left + viewportRect.width / 2;
      const isMobile = viewportRect.width < 750;
      if (isMobile) {
        setNeutralTransforms();
        return;
      }

      const range = Math.max(viewportRect.width * (isMobile ? 0.62 : 0.58), 1);
      const maxAngle = isMobile ? 0.88 : 0.76;
      const depthAmount = isMobile ? 54 : 68;
      const liftAmount = isMobile ? 8 : 12;

      cards.forEach((card) => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.left + rect.width / 2;
        const offset = clamp((cardCenter - center) / range, -1.3, 1.3);
        const absOffset = Math.abs(offset);
        const angle = offset * maxAngle;
        const curve = 1 - Math.cos(angle);
        const rotateY = angle * -32;
        const rotateZ = angle * 1.5;
        const depth = curve * -depthAmount;
        const y = curve * liftAmount;
        const scale = 1 - curve * (isMobile ? 0.055 : 0.07);
        const opacity = clamp(1 - Math.max(absOffset - 1.02, 0) * 0.26, 0.88, 1);

        card.style.setProperty('--tt-reel-x', '0px');
        card.style.setProperty('--tt-reel-y', `${y.toFixed(2)}px`);
        card.style.setProperty('--tt-reel-z', `${depth.toFixed(2)}px`);
        card.style.setProperty('--tt-reel-rotate-y', `${rotateY.toFixed(2)}deg`);
        card.style.setProperty('--tt-reel-rotate-z', `${rotateZ.toFixed(2)}deg`);
        card.style.setProperty('--tt-reel-scale', scale.toFixed(3));
        card.style.setProperty('--tt-reel-opacity', opacity.toFixed(3));
      });
    };

    const requestUpdate = () => {
      if (frame) return;
      frame = true;
      window.requestAnimationFrame(updateCardTransforms);
    };

    const scrollByCard = (direction) => {
      const firstCard = cards[0];
      if (!firstCard) return;

      const cardRect = firstCard.getBoundingClientRect();
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      const distance = (cardRect.width + gap) * direction;
      viewport.scrollBy({ left: distance, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    };

    viewport.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    previousButton?.addEventListener('click', () => scrollByCard(-1));
    nextButton?.addEventListener('click', () => scrollByCard(1));

    if ('ResizeObserver' in window) {
      new ResizeObserver(requestUpdate).observe(viewport);
    }

    window.requestAnimationFrame(() => {
      updateCardTransforms();
    });
  };

  const initAll = () => {
    document.querySelectorAll(selector).forEach(initCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(selector).forEach(initCarousel);
  });
})();
